import { IEmptyStateProps } from './types';

export const EmptyState = ({ image, title, subtitle, children }: IEmptyStateProps) => (
  <div className="flex items-center flex-col px-6 py-8 bg-global-neuchatel-20 rounded-xl">
    {image && <div className="mb-6">{image}</div>}

    <p className="typography-heading-3 text-text-primary">{title}</p>

    {subtitle && (
      <p className="typography-paragraph-3 text-text-secondary text-center mt-2 whitespace-pre-line">{subtitle}</p>
    )}

    {children}
  </div>
);
